<body class="A4">
  <!-- Each sheet element should have the class "sheet" -->
  <!-- Page 1 -->
  <section class="sheet padding-10mm">
    <div class="d-flex align-items-center logo">
      <img [src]="logoImage"/>
    </div>
    <div class="post-overview" *ngIf="postContent">
      <div class="post-title">{{postContent.title}}</div>
      <div class="post-date">{{postContent.publishedDate | date: 'd MMMM yyyy'}}</div>
    </div>
    <div class="influencer-basic-info">
      <app-influencer-basic-information
        *ngIf="influencer"
        [influencer]="influencer"
        [showCountryFlagIcon]="true">
      </app-influencer-basic-information>
    </div>
    <pdf-viewer-footer></pdf-viewer-footer>
  </section>
  <!-- Page 2 -->
  <section class="sheet padding-10mm">
    <pdf-viewer-header></pdf-viewer-header>
    <div class="activity-chart">
      <div class="activity-title">
        <span>{{'page.post_overview.section_title.engagement' | translate}}</span>
      </div>
      <div class="activity-line-chart-body" *ngIf="postActivityLineChartData">
        <achoo-line-chart
          *ngIf="postActivityLineChartData"
          [chartData]="postActivityLineChartData"
          [legendXPosition]="30"
          [legendYPosition]="-5"
          [legendItemDistance]="1"
          [xLabelPaddingTop]="15"
          [spacingBottom]="10"
        ></achoo-line-chart>
      </div>
    </div>
    <div class="kpi-report-container">
      <kpi-report *ngIf="postKpi"
                  [kpi]="postKpi"
                  [showKpiStatus]="false">
      </kpi-report>
    </div>
    <div class="d-flex post-content-section" *ngIf="postContent">
      <div class="full-width">
        <div class="title-header">
          <span class="text-uppercase">{{'page.post_overview.section_title.post' | translate}}</span>
        </div>
        <div class="post-content-section-body">
          <post-content
            [postContent]="postContent"
            [postMentions]="postContent.mentions"
            [postSponsors]="postContent.sponsors"
            [platformIconUrl]="platformIconUrl"
          ></post-content>
        </div>
      </div>
    </div>
    <div class="d-flex flex-row">
      <div class="flex-g1">
        <div class="engagement-chart-container chart-container">
          <div class="row">
            <div class="col-md-12 post-activity-gauge-chart-body">
              <achoo-pie-chart *ngIf="postActivityGaugeChartData"
                               [chartData]="postActivityGaugeChartData"
                               [chartTitle]="'page.post_overview.section_title.engagements' | translate"
                               [height]="250"
                               [pieCenter]="[85, 40]"
                               [titleStyling]="{fontSize: '0.85rem'}"
                               [legend]="{x: 28, y: 24, itemMarginBottom: 3, useHTML: true, enabledNavigation: false}">
              </achoo-pie-chart>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-g1" *ngIf="postContent">
        <div class="d-flex flex-column same-influencer-top-5-posts">
          <div class="flex-g1 title-header">
            <span class="text-uppercase">{{'page.post_overview.section_title.top_posts' | translate}}</span>
          </div>
          <div class="flex-g1 top-5-posts-body">
            <same-influencer-top-five-posts
              [influencerId]="postContent.influencerId"
              [urlHash]="postContent.urlHash"
              [numberOfPosts]="6"
              [currentPost]="postContent"
            ></same-influencer-top-five-posts>
          </div>
        </div>
      </div>
    </div>
    <pdf-viewer-footer></pdf-viewer-footer>
  </section>
  <!-- Page 3 -->
  <section class="sheet padding-10mm">
    <pdf-viewer-header></pdf-viewer-header>
    <div class="top-exposures-container">
      <div class="influencer-section">
        <div class="header top-exposures">
          <span>{{'page.post_overview.section_title.related_posts' | translate}}</span>
        </div>
        <top-exposures  *ngIf="topExposures"
                        [platformList]="platforms"
                        [topExposures]="topExposures" >
        </top-exposures>
      </div>
    </div>
    <pdf-viewer-footer></pdf-viewer-footer>
  </section>
  <section class="sheet padding-10mm"></section>
</body>



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/post-overview-pdf-viewer/post-overview-pdf-viewer.component.html